/// <reference types="./check.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function check() {
  return $svg.square(
    256,
    "<rect width=\"256\" height=\"256\" fill=\"none\"/>\n    <polyline points=\"40 144 96 200 224 72\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\"/>",
  );
}
